<template>
    <div :style="mainClass">
        <div class="side-menu">
            <div class="bottom-menu-item">
                <div class="item-box" @click="open_chat">
                    <img src="../../assets/images/icon-customer-components.png" />
                    <div class="text">客服</div>
                </div>
            </div>
            <div class="bottom-menu-item">
                <div class="item-box" style="position:relative;">
                    <img src="../../assets/images/icon-app-components.png" />
                    <div class="text">手机端</div>
                    <img src="../../assets/images/mini-app-qrcode.jpg" class="miniapp" />
                </div>
            </div>
            <div class="bottom-menu-item">
                <div class="item-box" @click="onShareClick">
                    <img src="../../assets/images/icon-share-components.png" />
                    <div class="text">分享</div>
                </div>
            </div>
        </div>
        <div class="back-top" v-show="isBackToTopVisible" @click="scrollToTop" ref="backToTop">
            <div class="item-box">
                <img src="../../assets/images/icon-back-to-top-components.png" />
            </div>
        </div>
        <Chat ref="chat"></Chat>
    </div>
</template>
<script>
import {mapState} from 'vuex';
import { string } from 'tls';
export default{
    name:"SideMenu",
    props:{
        mainClass:{
            type:String,
            default:()=>{
                return `position: fixed;
                bottom: 90px;
                right: 60px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;`
            }
        },
        shareUrl: {
            type:string,
            default:''
        },
        isWorkWeixin: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState(['userInfo']),
        is_login() {
            return this.$store.state.is_login;
        },
    },
    data(){
        return{
            isBackToTopVisible:false
        }
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy(){
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods:{
        open_chat() {
            if(this.isWorkWeixin) {
                window.open(`https://work.weixin.qq.com/kfid/kfc6bd3ac9b42f50756`)
            } else {
                this.$refs.chat.showChat()
            }
        },
        async onShareClick(){
            var url = window.location.href
            if(this.shareUrl) {
                url = this.shareUrl
            }
            if(this.is_login) {
                if(url.indexOf("?") >= 0){
				    url = url + "&code="+this.userInfo.code
                }else{
                    url = url + "?code="+this.userInfo.code
                }

            }
            await navigator.clipboard.writeText(url);
            this.$layer.msg('复制分享链接成功');
        },
        handleScroll() {
            this.isBackToTopVisible = window.pageYOffset > 100; // 滚动超过 300px 显示
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
    }
}
</script>
<style lang="scss" scoped>
@import "./sidemenu.scss";
</style>
